<nav class="flex items-center justify-center gap-8" *ngIf="collectionTree$ | async as tree">
    <!-- ALL PRODUCTS -->
    <div class="relative"
         (mouseenter)="openMegaMenu()"
         (mouseleave)="closeMegaMenuDelayed()">
        <button class="nav-link" [class.text-primary]="megaMenuOpen">
            {{ 'nav.allProducts' | translate }}
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 transition-transform" [class.rotate-180]="megaMenuOpen" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
        </button>
    </div>

    <!-- SECTORS -->
    <div class="relative"
         *ngIf="(sectorCollections$ | async) as sectors"
         [hidden]="!sectors.length"
         (mouseenter)="openSectorsMenu()"
         (mouseleave)="closeSectorsMenuDelayed()">
        <button class="nav-link" [class.text-primary]="sectorsMenuOpen">
            {{ 'nav.sectors' | translate }}
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 transition-transform" [class.rotate-180]="sectorsMenuOpen" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
        </button>
    </div>

    <!-- BEST SELLERS -->
    <a class="nav-link" (click)="scrollToSection('best-sellers')" *ngIf="hasBestSellers$ | async">{{ 'nav.bestSellers' | translate }}</a>

    <!-- BRANDS -->
    <a class="nav-link" (click)="scrollToSection('brands')" *ngIf="hasBrands$ | async">{{ 'nav.brands' | translate }}</a>

    <!-- NEW PRODUCTS -->
    <a class="nav-link" (click)="scrollToSection('new-products')">{{ 'nav.newProducts' | translate }}</a>
</nav>

<!-- Mega Menu Dropdown -->
<div *ngIf="megaMenuOpen && (collectionTree$ | async) as tree"
     class="mega-menu"
     (mouseenter)="keepMegaMenuOpen()"
     (mouseleave)="closeMegaMenuDelayed()">
    <div class="mega-menu-inner">
        <!-- Left: Parent Collections -->
        <div class="mega-menu-sidebar">
            <a *ngFor="let collection of tree.children"
               class="sidebar-item"
               [class.active]="hoveredCollection?.id === collection.id"
               (mouseenter)="onHoverMainCollection(collection)"
               (click)="navigateTo(collection.slug)">
                <img *ngIf="collection.featuredAsset?.preview"
                     [src]="collection.featuredAsset.preview + '?preset=tiny'"
                     class="sidebar-icon"
                     alt="" />
                <div *ngIf="!collection.featuredAsset?.preview" class="sidebar-icon-placeholder"></div>
                <span class="sidebar-label">{{ collection.name }}</span>
            </a>
        </div>

        <!-- Vertical Divider -->
        <div class="mega-menu-divider"></div>

        <!-- Right: Sub Collections (recursive for unlimited depth) -->
        <div class="mega-menu-content" *ngIf="hoveredCollection?.children?.length">
            <ng-container *ngFor="let sub of hoveredCollection.children">
                <ng-container *ngTemplateOutlet="recursiveNode; context: { $implicit: sub, depth: 0 }"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<!-- Sectors Mega Menu -->
<div *ngIf="sectorsMenuOpen && (sectorCollections$ | async) as sectors"
     class="mega-menu"
     (mouseenter)="keepSectorsMenuOpen()"
     (mouseleave)="closeSectorsMenuDelayed()">
    <div class="mega-menu-inner">
        <div class="mega-menu-sidebar">
            <a *ngFor="let sector of sectors"
               class="sidebar-item"
               (click)="navigateTo(sector.slug)">
                <img *ngIf="sector.featuredAsset?.preview"
                     [src]="sector.featuredAsset.preview + '?preset=tiny'"
                     class="sidebar-icon"
                     alt="" />
                <div *ngIf="!sector.featuredAsset?.preview" class="sidebar-icon-placeholder"></div>
                <span class="sidebar-label">{{ sector.name }}</span>
            </a>
        </div>
    </div>
</div>

<!-- Recursive sub-collection template -->
<ng-template #recursiveNode let-node let-depth="depth">
    <div class="sub-group" [style.padding-inline-start.px]="depth * 16">
        <div class="sub-item" [class.sub-item-child]="depth > 0" (click)="navigateTo(node.slug)">
            <span class="sub-item-label">{{ node.name }}</span>
            <button *ngIf="node.children?.length"
                    class="sub-item-toggle"
                    (click)="toggleExpanded(node.id, $event)">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 transition-transform"
                     [class.rotate-90]="isExpanded(node.id)"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
        <div *ngIf="node.children?.length && isExpanded(node.id)" class="sub-expanded">
            <ng-container *ngFor="let child of node.children">
                <ng-container *ngTemplateOutlet="recursiveNode; context: { $implicit: child, depth: depth + 1 }"></ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>
